<template>
  <svg
    v-if="thumbnail === 'navbar-logo-left'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path d="M0 5a5 5 0 0 1 5-5h120a5 5 0 0 1 5 5v12H0V5Z" fill="#fff" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M9 8h11v2H9zM67 8h7v1h-7zM82 8h7v1h-7zM97 8h7v1h-7zM112 8h7v1h-7z"
    />
    <path
      d="M.5 5A4.5 4.5 0 0 1 5 .5h120a4.5 4.5 0 0 1 4.5 4.5v11.5H.5V5Z"
      stroke="#000"
      stroke-opacity=".22"
    />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'hero-heading-right'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#333" d="M8 24h45v39H8z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M68 28h27v2H68zM68 24h35v2H68zM68 58h13v5H68zM68 36h54v1H68zM68 39h54v1H68zM68 42h54v1H68zM68 45h43v1H68z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'hero-heading-left'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M8 28h27v2H8zM8 24h35v2H8zM8 58h13v5H8zM8 36h54v1H8zM8 39h54v1H8zM8 42h54v1H8zM8 45h43v1H8z"
    />
    <path fill="#333" d="M77 24h45v39H77z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'hero-no-image'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M49 31h36v2H49zM35 27h63v2H35zM60 57h13v5H60zM31 39h72v1H31zM31 42h72v1H31zM31 45h72v1H31zM38 48h57v1H38z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'hero-stack'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M48 24h35v2H48zM59 39h13v5H59zM38 30h54v1H38zM44 33h43v1H44z"
    />
    <path fill="#333" d="M25 52h80v20H25z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'form-contact'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" fill="#F2F2F2" rx="5" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#000" fill-opacity=".8" d="M40.25 59.25h51.5v6.5h-51.5z" />
    <path fill="#fff" d="M40.25 39h51.5v6.5h-51.5z" />
    <path stroke="#000" stroke-opacity=".8" d="M40.75 39.5h50.5V45h-50.5z" />
    <path fill="#fff" d="M40.25 48.625h51.5v6.5h-51.5z" />
    <path stroke="#000" stroke-opacity=".8" d="M40.75 49.125h50.5v5.5h-50.5z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M53.464 24h23.679v2H53.464zM48.5 29h33v1h-33zM51.447 32h27.696v1H51.447z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect width="129" height="86" x=".5" y=".5" stroke="#5A5A5A" stroke-opacity=".13" rx="4.5" />
  </svg>
  <svg
    v-else-if="thumbnail === 'form-newsletter'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
  >
    <rect width="130" height="87" fill="#F2F2F2" xmlns="http://www.w3.org/2000/svg" rx="5" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#000" fill-opacity=".8" d="M37 34h56v1H37zM42 37h47v1H42zM77 49h16v6.5H77z" />
    <path stroke="#000" stroke-opacity=".8" d="M37.5 49.5h35V55h-35z" />
    <path fill="#000" fill-opacity=".8" d="M46 28h39v2H46z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect width="129" height="86" x=".5" y=".5" stroke="#5A5A5A" stroke-opacity=".13" rx="4.5" />
  </svg>

  <svg
    v-else-if="thumbnail === 'team-circles'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#000" fill-opacity=".8" d="M47 24h39v2H47zM31 29h72v1H31zM38 33h57v1H38z" />
    <rect x="32" y="41" width="15" height="15" rx="7.5" fill="#333" />
    <path fill="#000" fill-opacity=".8" d="M32 59h15v1H32zM34 63h11v1H34z" />
    <rect x="58.5" y="41" width="15" height="15" rx="7.5" fill="#333" />
    <path fill="#000" fill-opacity=".8" d="M58.5 59h15v1h-15zM60.5 63h11v1h-11z" />
    <rect x="85" y="41" width="15" height="15" rx="7.5" fill="#333" />
    <path fill="#000" fill-opacity=".8" d="M85 59h15v1H85zM87 63h11v1H87z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'team-rectangles'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#000" fill-opacity=".8" d="M53 21h27v2H53zM41 26h52v1H41zM46 29h41v1H46z" />
    <path fill="#F2F2F2" d="M17 50h28v16H17z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M19.24 54h11.2v2h-11.2zM19.24 58h21.28v1H19.24zM19.24 61h16.8v1h-16.8z"
    />
    <path fill="#333" d="M17 36h28v15H17z" />
    <path fill="#F2F2F2" d="M52 50h28v16H52z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M54.24 54h11.2v2h-11.2zM54.24 58h21.28v1H54.24zM54.24 61h16.8v1h-16.8z"
    />
    <path fill="#333" d="M52 36h28v15H52z" />
    <path fill="#F2F2F2" d="M87 50h28v16H87z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M89.24 54h11.2v2h-11.2zM89.24 58h21.28v1H89.24zM89.24 61h16.8v1h-16.8z"
    />
    <path fill="#333" d="M87 36h28v15H87z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'logos-quote-block'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#F2F2F2" d="M17 30h48v27H17z" />
    <path fill="#000" fill-opacity=".8" d="M21 34h36v2H21zM21 38h26v2H21z" />
    <path fill="#333" d="M21 47h6v6h-6z" />
    <path fill="#000" fill-opacity=".8" d="M30 47h14v1H30zM30 50h10v1H30zM78 30h11v4H78z" />
    <rect x="101" y="41" width="12" height="4" rx="2" fill="#000" fill-opacity=".8" />
    <rect x="78" y="53" width="12" height="4" rx="2" fill="#000" fill-opacity=".8" />
    <path
      d="M112 29a5 5 0 0 0-5 5h5v-5ZM107 34h-5v-5a5 5 0 0 1 5 5Z"
      fill="#000"
      fill-opacity=".8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M77.98 46.748v-3.223l6.478-3.223v3.223l-6.477 3.223ZM84.49 46.843v-3.27L91 40.302v3.27l-6.51 3.271ZM108.667 54.333a3.334 3.334 0 0 0-6.667 0h6.667Z"
      fill="#000"
      fill-opacity=".8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M113 56.667a3.334 3.334 0 0 0-6.667 0H113Z"
      fill="#000"
      fill-opacity=".8"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'logos-title'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#000" fill-opacity=".8" d="M33.02 45h11v4h-11z" />
    <rect x="69.019" y="45" width="12" height="4" rx="2" fill="#000" fill-opacity=".8" />
    <rect x="105.02" y="45" width="12" height="4" rx="2" fill="#000" fill-opacity=".8" />
    <path
      d="M98.02 45a5 5 0 0 0-5 5h5v-5ZM93.02 50h-5v-5a5 5 0 0 1 5 5Z"
      fill="#000"
      fill-opacity=".8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 50.446v-3.223L19.478 44v3.223L13 50.446ZM19.51 50.541v-3.27L26.02 44v3.27l-6.51 3.271ZM57.686 47.334a3.334 3.334 0 0 0-6.666 0h6.666Z"
      fill="#000"
      fill-opacity=".8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.02 49.667a3.334 3.334 0 0 0-6.667 0h6.666Z"
      fill="#000"
      fill-opacity=".8"
    />
    <path fill="#000" fill-opacity=".8" d="M54 31h26v2H54z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'gallery-overview'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M19 25h21v2H19zM19 31h21v1H19zM19 37h21v1H19zM19 34h21v1H19z"
    />
    <path
      fill="#333"
      d="M49 25h28v12H49zM49 61h28v10H49zM80 48h28v10H80zM49 40h28v18H49zM80 25h28v20H80zM80 61h28v10H80z"
    />
    <path fill="#000" fill-opacity=".8" d="M19 43h13v5H19z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'gallery-scroll'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#333" d="M54 16h55v17H54z" />
    <path fill="#fff" d="M57 28h9v2h-9z" />
    <path fill="#333" d="M54 36h55v19H54z" />
    <path fill="#fff" d="M57 50h13v2H57z" />
    <path fill="#333" d="M54 58h55v13H54z" />
    <path fill="#fff" d="M57 66h13v2H57z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M19 23h21v1H19zM19 29h21v1H19zM19 32h21v1H19zM19 35h18v1H19zM19 26h18v1H19z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'features-list'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#000" fill-opacity=".8" d="M17 29h27v2H17z" />
    <path fill="#333" d="M71 27h8v8h-8z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M83 27h30v1H83zM83 30h27v1H83zM17 35h40v1H17zM17 38h38v1H17zM17 41h38v1H17zM17 47h10v1H17z"
    />
    <path fill="#333" d="M71 39h8v8h-8zM71 51h8v8h-8z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M83 39h30v1H83zM83 51h30v1H83zM83 42h27v1H83zM83 54h27v1H83z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'features-metrics'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M22 39h12v2H22zM19 45h18v1H19zM22 48h12v1H22zM50 39h8v2h-8zM73 39h14v2H73zM102 39h8v2h-8zM47 45h14v1H47zM50 48h8v1h-8zM71 45h18v1H71zM74 48h12v1H74zM99 45h14v1H99zM102 48h8v1h-8z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'pricing-comparison'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#F2F2F2" d="M52 24h24v47H52z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M60 33h8v2h-8zM57 39h14v1H57zM59 56h12v1H59zM59 59h12v1H59zM59 62h12v1H59zM57 56h1v1h-1zM57 59h1v1h-1zM57 62h1v1h-1zM59 65h12v1H59zM57 65h1v1h-1zM60 42h8v1h-8z"
    />
    <path fill="#F2F2F2" d="M81 28h24v43H81z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M87 33h12v2H87zM88 56h12v1H88zM88 59h12v1H88zM88 62h12v1H88zM86 56h1v1h-1zM86 59h1v1h-1zM86 62h1v1h-1zM88 65h12v1H88zM86 65h1v1h-1zM84 39h18v1H84zM87 42h12v1H87zM85 47h16v5H85zM56 47h16v5H56z"
    />
    <path fill="#F2F2F2" d="M23 28h24v43H23z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M31 33h8v2h-8zM26 39h18v1H26zM29 42h12v1H29zM30 56h12v1H30zM30 59h12v1H30zM30 62h12v1H30zM28 56h1v1h-1zM28 59h1v1h-1zM28 62h1v1h-1zM30 65h12v1H30zM28 65h1v1h-1zM27 47h16v5H27z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'pricing-items'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#F2F2F2" d="M45 29h71v28H45z" />
    <path fill="#333" d="M14 29h31v28H14z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M51 35h11v1H51zM51 47h8v1h-8zM51 50h11v1H51zM75 47h8v1h-8zM75 50h11v1H75zM102 47h8v1h-8zM99 50h11v1H99zM51 38h21v2H51zM98 38h12v2H98z"
    />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'testimonial-column-dark'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#F2F2F2" d="M38 33h31v28H38zM72 33h21v28H72zM96 33h21v28H96z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M42 38h23v1H42zM42 41h23v1H42zM42 44h19v1H42zM42 56h8v1h-8zM75 38h15v1H75zM75 41h15v1H75zM75 44h13v1H75zM81 53h7v1h-7zM42 52h21v2H42zM51 25h28v2H51z"
    />
    <rect x="74" y="52" width="5" height="5" rx="2.5" fill="#303030" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M99 38h15v1H99zM99 41h15v1H99zM99 44h13v1H99zM105 53h7v1h-7zM81 56h4v1h-4zM105 56h4v1h-4z"
    />
    <path fill="#333" d="M16 33h22v28H16z" />
    <rect x="98" y="52" width="5" height="5" rx="2.5" fill="#303030" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'testimonial-column-light'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path fill="#000" fill-opacity=".8" d="M51 25h28v2H51z" />
    <path fill="#F2F2F2" d="M85 49h26v12H85z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M96.917 52h10.833v2H96.917zM85 38h26v1H85zM85 35h26v1H85zM85 41h26v1H85zM96.917 56h4.333v1h-4.333zM85 44h19.5v1H85z"
    />
    <rect x="88" y="52" width="6" height="6" rx="3" fill="#303030" />
    <path fill="#F2F2F2" d="M52 49h26v12H52z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M63.917 52H74.75v2H63.917zM52 38h26v1H52zM52 35h26v1H52zM52 41h26v1H52zM63.917 56h4.333v1h-4.333zM52 44h19.5v1H52z"
    />
    <rect x="55.25" y="52" width="6" height="6" rx="3" fill="#303030" />
    <path fill="#F2F2F2" d="M19 49h26v12H19z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M30.917 52H41.75v2H30.917zM19 38h26v1H19zM19 35h26v1H19zM19 41h26v1H19zM30.917 56h4.333v1h-4.333zM19 44h19.5v1H19z"
    />
    <rect x="22.25" y="52" width="6" height="6" rx="3" fill="#303030" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'testimonial-image-left'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M61 39h46v1H61zM61 36h46v1H61zM61 42h39v1H61zM61 57h8v1h-8zM61 53h21v2H61zM61 30h39v2H61z"
    />
    <path fill="#333" d="M22 30h35v28H22z" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'testimonial-stack'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path fill="#fff" d="M0 15h130v57H0z" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M37 34h56v1H37zM37 31h56v1H37zM42 37h47v1H42zM61 62h8v1h-8zM57 58h16v2H57zM46 25h39v2H46z"
    />
    <rect x="60" y="45" width="10" height="10" rx="5" fill="#303030" />
    <path stroke="#000" stroke-opacity=".22" d="M.5 15.5h129v56H.5z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'footer-dark'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#F2F2F2" />
    <path d="M0 56h130v26a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V56Z" fill="#fff" />
    <path
      fill="#000"
      fill-opacity=".8"
      d="M18 64h10v2H18zM53 64h8v2h-8zM77 64h10v2H77zM101 64h8v2h-8zM53 70h14v1H53zM53 76h14v1H53zM53 73h12v1H53zM53 79h12v1H53zM77 70h14v1H77zM77 76h14v1H77zM77 73h12v1H77zM77 79h12v1H77zM101 70h14v1h-14zM101 76h14v1h-14zM101 73h12v1h-12zM101 79h12v1h-12z"
    />
    <path
      d="M.5 56.5h129V82a4.5 4.5 0 0 1-4.5 4.5H5A4.5 4.5 0 0 1 .5 82V56.5Z"
      stroke="#000"
      stroke-opacity=".22"
    />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#5A5A5A" stroke-opacity=".13" />
  </svg>

  <svg
    v-else-if="thumbnail === 'new-page'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" fill="#18A0FB" fill-opacity=".11" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#18A0FB" />
  </svg>
  <svg
    v-else-if="thumbnail === 'section-container'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#18A0FB" fill-opacity=".04" />
    <path
      d="m19.664 47.5-.602-.602 2.477-2.468H10.875v-.86h10.664l-2.477-2.476.602-.594 3.5 3.5-3.5 3.5Z"
      fill="#18A0FB"
    />
    <path fill="#18A0FB" fill-opacity=".11" d="M30.5 10.5h69v66h-69z" />
    <path stroke="#18A0FB" d="M30.5 10.5h69v66h-69z" />
    <path
      d="m110.086 47.5-3.5-3.5 3.5-3.5.602.594-2.477 2.476h10.664v.86h-10.664l2.477 2.468-.602.602Z"
      fill="#18A0FB"
    />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#0062A4" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === '2-col'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#18A0FB" fill-opacity=".04" />
    <path fill="#18A0FB" fill-opacity=".11" d="M10.5 10.5H65v66H10.5z" />
    <path stroke="#18A0FB" d="M10.5 10.5H65v66H10.5z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M65 10.5h54.5v66H65z" />
    <path stroke="#18A0FB" d="M65 10.5h54.5v66H65z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#0062A4" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === '3-col'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#18A0FB" fill-opacity=".04" />
    <path fill="#18A0FB" fill-opacity=".11" d="M10.5 10.5h36.333v66H10.5z" />
    <path stroke="#18A0FB" d="M10.5 10.5h36.333v66H10.5z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M46.833 10.5h36.333v66H46.833z" />
    <path stroke="#18A0FB" d="M46.833 10.5h36.333v66H46.833z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M83.167 10.5H119.5v66H83.167z" />
    <path stroke="#18A0FB" d="M83.167 10.5H119.5v66H83.167z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#0062A4" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === '4-col'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#18A0FB" fill-opacity=".04" />
    <path fill="#18A0FB" fill-opacity=".11" d="M10.5 10.5h27.25v66H10.5z" />
    <path stroke="#18A0FB" d="M10.5 10.5h27.25v66H10.5z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M37.75 10.5H65v66H37.75z" />
    <path stroke="#18A0FB" d="M37.75 10.5H65v66H37.75z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M65 10.5h27.25v66H65z" />
    <path stroke="#18A0FB" d="M65 10.5h27.25v66H65z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M92.25 10.5h27.25v66H92.25z" />
    <path stroke="#18A0FB" d="M92.25 10.5h27.25v66H92.25z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#0062A4" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === 'heading-3-col'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#18A0FB" fill-opacity=".04" />
    <path fill="#18A0FB" fill-opacity=".11" d="M10.5 10.5h109v19h-109z" />
    <path stroke="#18A0FB" d="M10.5 10.5h109v19h-109z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M10.5 29.5h36.333v47H10.5z" />
    <path stroke="#18A0FB" d="M10.5 29.5h36.333v47H10.5z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M46.833 29.5h36.333v47H46.833z" />
    <path stroke="#18A0FB" d="M46.833 29.5h36.333v47H46.833z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M83.167 29.5H119.5v47H83.167z" />
    <path stroke="#18A0FB" d="M83.167 29.5H119.5v47H83.167z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#0062A4" stroke-opacity=".13" />
  </svg>
  <svg
    v-else-if="thumbnail === '2-by-2-grid'"
    width="130"
    height="87"
    viewBox="0 0 130 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="130" height="87" rx="5" fill="#18A0FB" fill-opacity=".04" />
    <path fill="#18A0FB" fill-opacity=".11" d="M10.5 10.5H65v33H10.5z" />
    <path stroke="#18A0FB" d="M10.5 10.5H65v33H10.5z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M65 10.5h54.5v33H65z" />
    <path stroke="#18A0FB" d="M65 10.5h54.5v33H65z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M10.5 43.5H65v33H10.5z" />
    <path stroke="#18A0FB" d="M10.5 43.5H65v33H10.5z" />
    <path fill="#18A0FB" fill-opacity=".11" d="M65 43.5h54.5v33H65z" />
    <path stroke="#18A0FB" d="M65 43.5h54.5v33H65z" />
    <rect x=".5" y=".5" width="129" height="86" rx="4.5" stroke="#0062A4" stroke-opacity=".13" />
  </svg>
</template>

<script setup>
defineProps(['thumbnail', 'color']);
</script>
